<template lang="pug">
GenericCard.customer-insight(size='75')
  CustomerDetailHeader.px-4.py-4(:data='data')
  .d-flex.blue-gradient.py-3.px-2
    //- NumberWithDescription(
    //-   v-if='data.unpaid'
    //-   :number='data.unpaid.count'
    //-   description='รายการสั่งซื้อ<br>ในรอบปีที่ผ่านมา'
    //- )
    //- p {{data}}
    NumberWithDescription(
      :number='data.account.problematic_checks_recent'
      description='เช็คที่มีปัญหา<br>ในรอบ 12 เดือน'
    )
    NumberWithDescription(
      :number='data.account.problematic_checks'
      description='เช็คที่มีปัญหา<br>ทั้งหมด'
    )
    NumberWithDescription(
      :number='data.account.average_payment_time'
      description='ระยะเวลา<br>การชำระเงิน<br>โดยเฉลี่ย'
    )

  template(v-if='isLoading')
    .py-4.flex-fill
      LoadingIndicator

  template(v-else)
    #recent.d-flex.flex-column.mt-2
      .bg-white
        .d-flex.justify-content-between.p-3
          .text-large รายการสั่งซื้อล่าสุด
          //- CustomDatePicker(
          //-   v-model='recentFilterDate'
          //-   :disabled='true'
          //- )
        hr.m-0
      template(v-if='recentTableData === null || recentTableData === undefined')
        LoadingError(
          title='เกิดข้อฟิดพลาดในการโหลดรายการ'
          @reload='loadRecent'
        )
      template(v-else)
        CustomTable.mx-3(
          :columns='recentTableColumns'
          :data='filteredRecentList'
          :itemClickable='false'
        )

    #outstanding.d-flex.flex-column
      OutstandingListCore(
        :customerId='this.data.id'
        :sticky='false'
      )
      //- .bg-white
      //-   .d-flex.justify-content-between.px-4.py-3
      //-     .text-large รายการค้างชำระ
      //-     CustomDatePicker(v-model='unpaidFilterDate')
      //-   hr.m-0
      //- CustomTable.mx-3(
      //-   :columns='unpaidTableColumns'
      //-   :data='filteredUnpaidList'
      //- )
</template>

<script>
/* eslint-disable arrow-body-style */
import CustomerDetailHeader from './CustomerDetailHeader.vue';
// import OutstandingListCore from '@/components/dashboard/panels/OutstandingListCore.vue';
import OutstandingListCore from '../dashboard/panels/OutstandingListCore.vue';

export default {
  props: {
    data: {
      defaultValue: {
        image: '',
      },
    },
    // customerId: {
    //   default: undefined,
    // },
  },
  computed: {
    filteredRecentList() {
      // return this.recentTableData.filter((item) => {
      //   // return (this.filterProvince === '' || item.province === this.filterProvince)
      //   return (this.recentFilterDate === '')
      //       || (this.$dateUtils.isInRange(item.dueDate, this.recentFilterDate));
      // });
      return this.recentTableData;
    },
    filteredUnpaidList() {
      // return this.unpaidTableData.filter((item) => {
      //   // return (this.filterProvince === '' || item.province === this.filterProvince)
      //   return (this.unpaidFilterDate === '')
      //       || (this.$dateUtils.isInRange(item.dueDate, this.unpaidFilterDate));
      // });
      return this.unpaidTableData;
    },
  },
  data: () => ({
    isLoading: false,

    // recentFilterDate: '',
    recentTableData: [],
    recentTableColumns: {
      // dueDate: {
      //   title: 'ครบกำหนด',
      //   align: 'center',
      //   type: Date,
      // },
      created_at: {
        title: 'วันที่ทำรายการ',
        align: 'center',
        type: Date,
      },
      productId: {
        title: 'รหัสสินค้า',
        align: 'left',
      },
      productName: {
        title: 'ชื่อสินค้า',
        align: 'left',
      },
      amount: {
        title: 'จำนวน',
        align: 'right',
      },
      price: {
        title: 'ราคาขาย',
        align: 'right',
        type: Number,
      },
      total: {
        title: 'ยอดรวม',
        align: 'right',
        type: Number,
      },
    },

    unpaidFilterDate: '',
    unpaidTableColumns: {
      dueDate: {
        title: 'กำหนดจ่าย',
        align: 'center',
        type: Date,
      },
      documentCode: {
        title: 'เลขที่เอกสาร',
        align: 'left',
      },
      customerName: {
        title: 'ชื่อลูกค้า',
        align: 'left',
      },
      total: {
        title: 'ราคาขาย',
        align: 'right',
        type: Number,
      },
      overDueDateCount: {
        title: 'วันที่เกิน',
        align: 'right',
      },
    },
    unpaidTableData: [],
  }),
  watch: {
    data() {
      this.loadRecent();
    },
  },
  mounted() {
    this.loadRecent();
  },
  methods: {
    // async loadInsight() {
    //   this.loadRecent();
    //   // this.loadUnpaid();
    // },

    async loadRecent() {
      this.isLoading = true;
      try {
        const res = await this.$api.customer.history.productPurchase(this.data.id);
        if (res.status === 200) {
          const recent = (res.data && res.data.data) ? res.data.data.splice(0, 5) : [];
          // console.log(recent);
          this.recentTableData = recent;
        }
      } catch (e) {
        this.recentTableData = null;
        // console.log(e);
      }

      this.isLoading = false;
    },
  },
  components: {
    CustomerDetailHeader,
    OutstandingListCore,
  },
};
</script>

<style lang="scss">
.customer-insight {
  // some styles here
}

.customer-stat {
  display: flex;
  background: linear-gradient(#EDF7FB, rgba(#fff, 0.0));
  .item {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
    .key {
      font-size: 13px;
      opacity: 0.5;
      letter-spacing: 1px;
      text-align: center;
      text-overflow: clip;
    }
    .value {
      font-size: 28px;
      letter-spacing: 2px;
    }
  }
}
</style>
